/**
 * Functions related to the pricing plan that the user is on, this information is
 * mostly captured in a "planId" string that we store with each purchase on Stripe
 * and this module helps parse that string and determine what plan the user is on.
 */
const FREE_PLAN = {
    planId: null,
    type: 'free',
};
function translatePlanType(type) {
    switch (type) {
        case 'free':
            return 'free';
        // Note, "professional" used to be called "premium"
        case 'premium':
            return 'professional';
        case 'pro':
            return 'professional';
        case 'professional':
            return 'professional';
        case 'clinic':
            return 'clinic';
        case 'enterprise':
            return 'enterprise';
        default:
            return 'unknown';
    }
}
/**
 * Given the plan id string i.e. premium-monthly-v1, plan-default-usd-pro_monthly-v2, premium-yearly-v1
 * parse the plan so that we can have the details
 */
export function parsePlanString(planId) {
    if (!planId) {
        return FREE_PLAN;
    }
    if (planId.endsWith('v1')) {
        const [planType, interval, version] = planId.split('-');
        return {
            planId,
            type: translatePlanType(planType),
            version: version,
            interval: interval,
        };
    }
    if (planId.endsWith('v2')) {
        const [_, __, currency, planTypeInterval, version] = planId.split('-');
        const [type, interval] = planTypeInterval.split('_');
        return {
            planId,
            type: translatePlanType(type),
            version: version,
            interval: interval,
            currency,
        };
    }
    if (planId.startsWith('price') || // custom price item in Stripe
        planId.startsWith('plan_') || // custom price item in Stripe
        planId === '50% off old user' // a somewhat rare human-readable price tier {
    ) {
        return {
            planId,
            type: 'unknown',
        };
    }
    return FREE_PLAN;
}
/**
 * Given a planId and a seatCount return what plan the user is on
 * @param planId string A string like "plan-default-usd-pro_monthly-v2" which is used to capture what sort of plan the user is on
 * @param seatCount number The number of seat licenses the user has purchased
 */
export function determinePlan(planId, seatCount) {
    if (planId) {
        const plan = parsePlanString(planId);
        if (seatCount >= 50) {
            plan.type = 'enterprise';
            return plan;
        }
        // Often there will be plans like price_<identifier> which default
        // to "unknown" however, the vast majority of time these are clinic
        // accounts, and thus enterprise accounts if the seat count is over 50
        // see https://doxyme.slack.com/archives/C016RUTSMHR/p1733747180068829
        if (plan.type === 'unknown') {
            plan.type = 'clinic';
            if (seatCount >= 50) {
                plan.type = 'enterprise';
                return plan;
            }
            return plan;
        }
        return plan;
    }
    return {
        type: 'free',
        planId: undefined,
    };
}
